<template>
  <div>
      <el-dialog
          title="Edit Annotation"
          :visible.sync="show_edit_overlay"
          width="90%">
        <annotation
            :annotation_prop="overlay_annotation"
            :tags_prop="tags"
        />
    </el-dialog>
    <el-dialog
        title="Confirm Delete"
        :visible.sync="showConfirmCancel">

      <p>Are you sure you want to <strong>delete {{confirm_annotation_text}}?</strong></p>
      <el-button v-on:click="annotation_delete(confirm_annotation_id)" type="danger">Yes, really delete.</el-button>
      <el-button v-on:click="hideConfirmCancel()" type="success">Oops. Actually, do not delete.</el-button>

    </el-dialog>
    <el-row style="margin-bottom:20px;padding-bottom:5px;border-bottom:1px solid black;">
      <el-col :span="3">...</el-col>
      <el-col :span="6">    <h1>Annotations</h1></el-col>
      <el-col :span="6">
        URL <el-input style="display:inline" v-model="new_url"></el-input>
      </el-col>
      <el-col :span="3" style="margin-left:20px;">↓↓↓<el-button @click="new_annotation">Start annotation</el-button></el-col>
    </el-row>
    <el-row style="padding-bottom:20px;">
      <el-col :span="3">...</el-col>
      <el-col :span="15">
        <span style="margin-right:20px;">Show screenshots <el-switch v-model="show_screenshots"></el-switch></span>
        <span style="margin-right:20px;">Gallery <el-switch v-model="show_gallery_view"></el-switch></span>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid black;">
      <el-col :span="3">...</el-col>
      <el-col :span="15">
        <span style="margin-right:20px;">Filter by user <el-switch v-model="show_filter_by_user"></el-switch></span>
        <span v-if="show_filter_by_user" style="margin-right:20px;">
          <el-select filterable style="display:inline-block;width:100px;" v-model="filter_by_user" placeholder="Select">
            <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </span>
        <span style="margin-right:20px;"><el-input style="display: inline-block;width:140px;" placeholder="Filter by text" v-model="filter_text"></el-input></span>
        <span v-if="tags">
          <el-tag
              v-for="tag in tags"
              :key="tag.id"
              :type="tag.id===filter_by_tag_id ? 'success' : 'info'"
              :effect="tag.id===filter_by_tag_id ? 'dark' : 'light'"
              size="mini"
              @click="filter_on_tag(tag)"
              style="margin-right:5px;"
          >
            {{tag.name}} ({{tag.count}})
          </el-tag>
        </span>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid black;">
      <el-col :span="3">...</el-col>
      <el-col :span="15">
        <span style="margin-right:20px;">Filter by additional field <el-switch v-model="show_filter_by_field"></el-switch></span>

        <span v-if="show_filter_by_field">
        <el-select filterable v-model="additional_field" placeholder="Select">
          <el-option
              v-for="item in fields"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <el-tag
            v-for="value in field_values"
            :key="value"
            :type="value===filter_on_column_value ? 'success' : 'info'"
            :effect="value===filter_on_column_value ? 'dark' : 'light'"
            size="mini"
            @click="set_filter_on_column_value(value)"
            style="margin-right:5px;"
        >{{value}}</el-tag>
          </span>
      </el-col>
    </el-row>
    <el-row v-if="status_text">
      <div style="background-color:#FFCC4F;padding:20px;">{{status_text}}</div>
    </el-row>
    <div v-if="ready">
      <div v-if="show_gallery_view">
        <span style="width:20%;display:inline-block" v-for="annotation in filtered_annotations_list.filter(a => {return a.hasOwnProperty('screenshots') && a.screenshots})" >
            <img @click="annotation_edit(annotation)" width="100%" :src="annotation.screenshots[0].public_url" />
        </span>
      </div>
      <div v-else-if="show_screenshots">
        <el-row  v-for="annotation in filtered_annotations_list" style="padding-top: 18px; padding-bottom:18px;border-bottom:1px solid black;">
        <el-col :span="3">...</el-col>
        <el-col :span="9" style="margin-right:30px; ">
          <div v-if="annotation.screenshots">
            <a :href="annotation.screenshots[0].request_url" target="_blank">
              <img v-if="show_screenshots" width="100%" :src="annotation.screenshots[0].public_url" />
            </a>
          </div>
        </el-col>
        <el-col :span="9">
          <div v-if="annotation.processed_asset">
            <h4>{{annotation.processed_asset.title}}</h4>
          </div>
          <p>{{annotation.url}}</p>
          <div style="background:#E4E7E8;padding:10px;margin-bottom:30px;">
            <div>Observation</div>
            <div style="color:black"><strong>{{annotation.observation}}</strong></div>
          </div>
          <div style="background:#E4E7E8;padding:10px;margin-bottom:30px;">
            <div>Hypothesis/Question/Action</div>
            <div><strong style="color:black">{{annotation.hypothesis}}</strong></div>
          </div>
          <el-button @click="annotation_edit(annotation)" icon="el-icon-edit"></el-button>
          <el-button @click="annotation_delete_confirm(annotation)" icon="el-icon-delete"></el-button>
          <el-button v-if="annotation.processed_asset_id" @click="processed_asset_details(annotation.processed_asset_id)">See asset details</el-button>
        </el-col>
      </el-row>
      </div>
      <el-row v-else>
        <el-table
            :data="filtered_annotations_list"
            style="width: 100%">
          <el-table-column
              v-for = "column in table_display_info"
              v-bind:label = column.name
              v-bind:prop = column.prop
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'url' && scope.row.hasOwnProperty('tags')">
                <el-tag
                    v-for="tag in scope.row.tags"
                    :key="tag.name.en"
                    :type="tag.id===filter_by_tag_id ? 'success' : 'info'"
                    :effect="tag.id===filter_by_tag_id ? 'dark' : 'light'"
                    @click="filter_on_tag(tag)"
                    size="mini"
                >
                  {{tag.name.en}}
                </el-tag>
                <a @click="open_link(scope.row[column.prop])">{{scope.row[column.prop]}}</a>
              </span>
              <span v-if="column.prop === 'observation'">
                {{scope.row[column.prop]}}
              </span>
              <span v-if="column.prop === 'hypothesis'">
                {{scope.row[column.prop]}}
              </span>
              <span v-if="column.prop === 'buttons'">
                <el-button @click="annotation_edit(scope.row)" icon="el-icon-edit"></el-button>
                <el-button @click="annotation_delete_confirm(scope.row)" icon="el-icon-delete"></el-button>
                <el-button v-if="scope.row.processed_asset_id" @click="processed_asset_details(scope.row.processed_asset_id)" icon="el-icon-aim"></el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnnotationList",
  props: ['extent_id'],
  data() {
    return {
      table_display_info: [
        {name: 'URL', prop:'url'},
        {name: 'Observation', prop: 'observation'},
        {name: 'Hypothesis/Question/Action', prop: 'hypothesis'},
        {name: '',prop:'buttons'},
      ],
      annotations: [],
      ready: false,
      new_url: '',
      users: [],

      show_edit_overlay: false,
      overlay_annotation: null,

      show_gallery_view: false,

      show_screenshots: false,
      show_filter_by_user: false,
      filter_by_user: null,

      filter_by_tag_id: null,

      filter_text: '',

      fields: [],
      additional_field: null,
      filter_on_column_value: '',
      show_filter_by_field: false,

      ever_had_screenshots: false,

      showConfirmCancel: false,
      confirm_annotation_text: '',
      confirm_annotation_id: null,
      tags: [],

      waiting_on_data: false,
    }
  },
  mounted() {
    this.get()
  },
  watch: {
    url_options: function(val) {
      this.get()
    },
    show_gallery_view: function() {
      if (this.show_gallery_view) {
        this.show_screenshots = true
      }
    },
    show_screenshots: function() {
      if (this.show_gallery_view && !this.show_screenshots) {
        this.show_gallery_view = false
      }
    }
  },
  computed: {
    field_values: function() {
      if (!this.additional_field || !this.annotations) return null
      let values = []
      this.annotations.forEach(a => {
        if (a.asset) {
          let new_value = a.asset[this.additional_field]
          if (!values.includes(new_value)) {
            values.push(new_value)
          }
        }
      })
      return values
    },
    status_text: function() {
      if (this.waiting_on_data) {
        return 'Waiting on data'
      }
    },
    // annotations_prop OR via axios ==> annotations ==> filtered_annotations_users ==> filtered_annotations_tags ==> filter_annotations_column => filtered_annotations_list
    filtered_annotations_list: function() {
      if (!this.filter_text) {
        return this.filtered_annotations_column
      } else {
        return this.filtered_annotations_column.filter(a => {
          return (a.observation.toLowerCase().includes(this.filter_text.toLowerCase()) ||
              (a.hypothesis && a.hypothesis.toLowerCase().includes(this.filter_text.toLowerCase()))
          )
        })
      }
    },
    filtered_annotations_column: function() {
      if (!this.show_filter_by_field || !this.filter_on_column_value) {
        return this.filtered_annotations_tags
      } else {
        return this.filtered_annotations_tags.filter(a => {
          if (a.asset && a.asset[this.additional_field]) {
            return a.asset[this.additional_field] === this.filter_on_column_value;
          } else {
            return false
          }
        })
      }
    },
    filtered_annotations_tags: function() {
      if (!this.filter_by_tag_id) {
        return this.filtered_annotations_users
      } else {
        return this.filtered_annotations_users.filter(a => {
          let found = false
          a.tags.forEach(tag => {
            if (tag.id === this.filter_by_tag_id) {
              found = true
            }
          })
          return found

        })
      }
    },
    filtered_annotations_users: function() {
      if (!this.show_filter_by_user || !this.filter_by_user) {
        return this.annotations
      } else {
        return this.annotations.filter(a => {return a.user_id === this.filter_by_user})
      }
    },
    url_options: function () {
      let string = '?'
      if (this.ever_had_screenshots || (this.show_screenshots && !this.ever_had_screenshots)) {
        this.ever_had_screenshots = true
        string += 'show_screenshots=1'
      }
      return string
    },
  },
  methods: {
    set_filter_on_column_value(value) {
      if (this.filter_on_column_value===value) {
        this.filter_on_column_value = null
      } else {
        this.filter_on_column_value = value
      }
    },
    filter_on_tag(tag) {
      if (this.filter_by_tag_id===tag.id) {
        this.filter_by_tag_id = null
      } else {
        this.filter_by_tag_id = tag.id
      }
    },
    open_link(url) {
      window.open(url,"_blank")
    },
    processed_asset_details(processed_asset_id) {
      window.open("/assetdetails/" + this.extent_id + "/" + processed_asset_id,"_blank")
    },
    annotation_delete_confirm(annotation) {
      this.confirm_annotation_text = annotation.url
      this.confirm_annotation_id = annotation.id
      this.showConfirmCancel = true
    },
    hideConfirmCancel() {
      this.showConfirmCancel = false
    },
    annotation_delete(id) {
      axios.delete("/annotations/" + this.extent_id + "/" + id)
          .then(response => {
            console.log('deleted')
            this.showConfirmCancel = false
            this.get()
          }).catch(error => {
            console.log('could not delete annotation')
            console.log(error.response)
      })
    },
    annotation_edit(annotation) {
      this.overlay_annotation = annotation
      this.show_edit_overlay = true
    },
    new_annotation() {
      window.open("/annotations/" + this.extent_id + "/?url=" + this.new_url)
    },
    get() {
      this.waiting_on_data = true
      axios.get('/annotations/list_all/' + this.extent_id + this.url_options)
          .then(response => {
            this.annotations = response.data.annotations
            this.users = response.data.users
            this.tags = response.data.tags
            this.fields = response.data.fields
            if (!this.filter_by_user) this.filter_by_user = response.data.current_user_id
            console.log('got annotations')
            this.ready = true
            this.waiting_on_data = false
      }).catch(error => {
        this.ready = false
        this.annotations = []
        console.log('did not get annotations')
        console.log(error.response)
        this.waiting_on_data = false
      })
      //
    },
  }
}
</script>

<style scoped>

</style>